import React, { forwardRef, useImperativeHandle, useRef } from 'react'
import AddToCollectionIcon, {
  AddToCollectionIconApi,
} from 'components/Collection/V2/AddToCollectionIcon'
import AuthenticationConnect, {
  ConnectorProps as AuthenticationProps,
} from 'connectors/Authentication'
import { ActionItem } from './styles'

type Props = {
  artworkId: number
  handleOpenCreateCollectionsModal: () => void
  modalName?: string
} & AuthenticationProps

export type AddToCollectionApi = {
  handleCreateCollectionCallback: (payload: any) => void
  handleCloseCollectionsListModal: () => void
}

const AddToCollectionAction = forwardRef<AddToCollectionApi, React.PropsWithChildren<Props>>(
  (props, ref) => {
    const { artworkId, handleOpenCreateCollectionsModal, children, modalName } = props
    const addToCollectionIconRef = useRef<AddToCollectionIconApi>(null)

    const handleCreateCollectionCallback = (payload) => {
      addToCollectionIconRef.current?.addArtworkToCollection(payload)
    }

    const handleCloseCollectionsListModal = () => {
      addToCollectionIconRef.current?.closeCollectionsListModal()
    }

    useImperativeHandle(ref, () => ({
      handleCreateCollectionCallback,
      handleCloseCollectionsListModal,
    }))

    return children ? (
      <AddToCollectionIcon
        artworkId={artworkId}
        handleOpenCreateCollectionsModal={handleOpenCreateCollectionsModal}
        ref={addToCollectionIconRef}
        modalName={modalName}
      >
        {children}
      </AddToCollectionIcon>
    ) : (
      <ActionItem data-action='collection' data-type='action' title='Add to Collection'>
        <AddToCollectionIcon
          artworkId={artworkId}
          handleOpenCreateCollectionsModal={handleOpenCreateCollectionsModal}
          ref={addToCollectionIconRef}
        />
      </ActionItem>
    )
  }
)

export default AuthenticationConnect(AddToCollectionAction)
